export function opportunityUrl(opportunity,lang){
 const urls=opportunity?.external_urls || {};
 return [urls[lang],opportunity?.external_url,urls.it,urls.en].find(url=>typeof url==='string' && /^https?:\/\//i.test(url)) || null;
}
